var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { MenuItem } from '@material-ui/core';
import { useLanguageOnClose } from '../hooks';
const LanguageItem = (_a) => {
    var { children, forwardedRef, label = '', onClick } = _a, rest = __rest(_a, ["children", "forwardedRef", "label", "onClick"]);
    const onMenuClose = useLanguageOnClose();
    const onItemClick = () => {
        onMenuClose && onMenuClose();
        onClick && onClick();
    };
    return (React.createElement(MenuItem, Object.assign({ "aria-label": label, onClick: onItemClick, title: label, ref: forwardedRef }, rest, { button: true }), children));
};
LanguageItem.displayName = 'Navbar.LanguageItem';
LanguageItem.propTypes = {
    label: PropTypes.string,
    onClick: PropTypes.func,
};
const LanguageItemExtra = styled(forwardRef((props, ref) => React.createElement(LanguageItem, Object.assign({}, props, { forwardedRef: ref })))) ``;
export default LanguageItemExtra;
